import Breakpoints from 'components/style/Breakpoints.style';
import { Col } from 'reactstrap';
import styled from 'styled-components';
import { text } from 'components/style/Colors.style';

export const Title = styled.h5`
  color: ${text};
  text-align: left;
  font-weight: 500;
  margin-bottom: 1rem;
  word-break: break-word;
`;

export const Message = styled.label`
  color: ${text};
  text-align: left;
  white-space: pre-line;
  margin-bottom: 0px;
`;

export const Icon = styled.img`
  width: 100%;
  max-width: 30px;
  max-height: 30px;

  @media only screen and (max-width: ${Breakpoints.sm}) {
    max-width: 20px;
    max-height: 20px;
  }
`;

export const IconCol = styled(Col).attrs({ className: 'col-auto' })`
  padding: 13px 0px 0px 20px;
`;



// WEBPACK FOOTER //
// ./src/components/common/Notification/NotificationMessage/NotificationMessage.style.js